import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MastersCard from '../../components/MastersCard/MastersCard';
import { Masters as MastersEN } from '../../data/masters'; 
import { Masters as MastersRU } from '../../data/rumasters'; 
import './Masters.css';

const MastersPage: React.FC = () => {
  const { t, i18n } = useTranslation();

  // ✅ Select the correct masters data based on the current language
  const Masters = i18n.language === 'ru' ? MastersRU : MastersEN;

  return (
    <div className="Lectors-container">
      <div className="ctitle-container-courses">
        <h1 className="courses-title">{t("masters_title")}</h1>
        <h1 className="courses-subtext">{t("masters_subtext")}</h1>
      </div>
      <div className="masters-list">
        {Masters.map((master) => (
          <Link 
            to={`/masters/${master.id}`} 
            key={master.id} 
            style={{ textDecoration: 'none', color: 'inherit' }} 
          >
            <MastersCard
              image={master.photo}
              name={master.name}
              surname={master.surname}
              credentials={master.credentials}
              description={master.description}
            />
          </Link>
        ))}
      </div>
    </div>
  );
};

export default MastersPage;
